import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { FiItemBranchLinkImportFileHelperContainer } from '../../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class FiItemBranchLinkFileHelperService extends BaseApiTemplateService<FiItemBranchLinkImportFileHelperContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-branch-link-import-file-helpers/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-branch-link-import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-branch-link-import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}